/* __________________________  Add all products to the cart __________________________ */
let atcButtons = document.querySelectorAll('.diag-result__add-routine-to-cart');
atcButtons.forEach(atcButton => {
  atcButton.addEventListener("click", function () {
    let productsIds = atcButton.getAttribute("data-products-ids").split(";");
    productsIds = productsIds.filter(id => id.trim() !== "");
    addProducts(productsIds);
  });
});

/* __________________________   Update routine price when another variant is selected __________________________ */
document.documentElement.addEventListener('product:rerendered', () => {
  // HTML elements to update
  let totalPriceElement = document.querySelector('.price-details__product-total .price-details__price');
  let addRoutineToCartButton = document.querySelector('.price-details .diag-result__add-routine-to-cart');
  let totalPriceWithDeliveryElement = document.querySelector('.price-details__total .price-details__price');
  let nbOfProductsElement = document.querySelector('.price-details__product-total .price-details__label');
  let variantPickers = document.querySelectorAll('.diag-result__products-bundle variant-picker');
  let totalPrice = 0;
  let shippingCost = document.querySelector('.price-details__delivery').getAttribute('data-estimated-shipping-cost');
  let nbOfProducts = "";
  let variantsIds = "";

  // Get product infos from data-variant JSON (in variant-picker)
  const variantPrices = Array.from(variantPickers).map(item => {
    const variantText = item.querySelector('[data-variant]').innerText; // Get JSON text from the data-variant attribute
    const variant = JSON.parse(variantText); // Convert the JSON text to an object
    let variantInfo = "";
    if (variant.available) {
      variantInfo = {
        variant_id: variant.id,
        price: variant.price
      };
      return variantInfo; // If variant is available, return price
    } else {
      return null;
    }
  });
  const filteredVariantPrices = variantPrices.filter(item => item !== null); // Remove null values from the array

  // UPDATE PRICE
  totalPrice = filteredVariantPrices.reduce((acc, item) => acc + item.price, 0); // Use reduce to add price values
  totalPriceElement.innerHTML = formatMoney(totalPrice); // Format the price

  // UPDATE TOTAL PRICE WITH DELIVERY
  if (shippingCost == "free") {
    totalPriceWithDeliveryElement.innerHTML = formatMoney(totalPrice);
  } else {
    let formatteShippingCost = parseFloat(shippingCost.replace(",", "").replace("€", ""));
    let finalPrice = totalPrice + formatteShippingCost;
    totalPriceWithDeliveryElement.innerHTML = formatMoney(finalPrice);
  }

  // UPDATE VARIANTS IDS
  variantsIds = filteredVariantPrices.map(item => item.variant_id).join(";"); // Get all variant ids and join them with a ";"
  addRoutineToCartButton.setAttribute('data-products-ids', variantsIds);

  // UPDATE PRODUCTS NUMBER
  nbOfProducts = filteredVariantPrices.length;
  let textContent = nbOfProductsElement.textContent.split(" ")[1];
  nbOfProductsElement.innerHTML = nbOfProducts + " " + textContent;
  reloadTrustpilotWidget();
});

// Functions

async function addProducts(ids) {
  let formData = {
    'items': []
  };
  for (let i = 0; i < ids.length; i++) {
    formData.items.push({
      'id': ids[i],
      'quantity': 1,
      'properties': {
        '_Diag': true
      }
    });
  }
  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });
  const responseJson = await response.json();
  if (response.ok) {
    if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
      return window.location.href = `${Shopify.routes.root}cart`;
    }
    this.dispatchEvent(new CustomEvent("variant:added", {
      bubbles: true,
      detail: {
        variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
      }
    }));
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async response2 => {
      const cartContent = await response2.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
      cartContent["sections"] = responseJson["sections"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: window.themeVariables.settings.cartType === "drawer"
        }
      }));
    });
  }
}
function reloadTrustpilotWidget() {
  if (window.Trustpilot) {
    const trustboxes = document.getElementsByClassName("trustpilot-widget");
    for (let i = 0; i < trustboxes.length; i++) {
      window.Trustpilot.loadFromElement(trustboxes[i]);
    }
  } else {
    // Si le script Trustpilot n'est pas encore chargé, on le charge
    const trustpilotScript = document.createElement("script");
    trustpilotScript.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    trustpilotScript.async = true;
    document.head.appendChild(trustpilotScript);
    trustpilotScript.addEventListener('load', () => {
      const trustboxes = document.getElementsByClassName("trustpilot-widget");
      for (let i = 0; i < trustboxes.length; i++) {
        window.Trustpilot.loadFromElement(trustboxes[i]);
      }
    });
  }
}